class TypewriterSearch {
  constructor() {
    this.searchInputs = document.querySelectorAll('[data-typewriter-placeholder]');
    this.initializeAll();
  }

  initializeAll() {
    this.searchInputs.forEach(input => {
      const placeholders = JSON.parse(input.getAttribute('data-typewriter-placeholder'));
      this.initTypewriter(input, placeholders);
    });
  }

  initTypewriter(input, placeholders) {
    let placeholderIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let currentPlaceholder = '';

    const typewriterEffect = () => {
      const fullText = placeholders[placeholderIndex];
      
      if (isDeleting) {
        currentPlaceholder = fullText.substring(0, charIndex - 1);
        charIndex--;
      } else {
        currentPlaceholder = fullText.substring(0, charIndex + 1);
        charIndex++;
      }

      input.setAttribute('placeholder', currentPlaceholder);

      let typeSpeed = isDeleting ? 50 : 100;

      if (!isDeleting && charIndex === fullText.length) {
        typeSpeed = 2000; // Pause at end
        isDeleting = true;
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        placeholderIndex = (placeholderIndex + 1) % placeholders.length;
        typeSpeed = 500; // Pause before new word
      }

      setTimeout(typewriterEffect, typeSpeed);
    };

    // Start the effect
    typewriterEffect();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new TypewriterSearch());
} else {
  new TypewriterSearch();
}

// Re-initialize when new search inputs are added dynamically
const observer = new MutationObserver(() => {
  const newInputs = document.querySelectorAll('[data-typewriter-placeholder]:not([data-typewriter-initialized])');
  if (newInputs.length > 0) {
    newInputs.forEach(input => {
      input.setAttribute('data-typewriter-initialized', 'true');
    });
    new TypewriterSearch();
  }
});

observer.observe(document.body, { childList: true, subtree: true });